import { useEffect, useMemo, useState } from 'react'
import { withPrefix } from 'gatsby'
import { AuthorizationApi } from '../api/authorization'

function buildAuthPath(sufixPath) {
  const host = process.env.GATSBY_DOMAIN
  const path = withPrefix(`/${sufixPath}`)

  return `${host}${path}`
}

function getBootstrapOfCAS() {
  const AuthService = require('@hotmart/cas-js').default
  const { Bootstrap } = require('@hotmart/cas-js')
  const clientId = process.env.GATSBY_AUTH_CLIENT_ID
  const login = buildAuthPath('login')
  const renew = buildAuthPath('renew')
  const logout = buildAuthPath('logout')

  const authService = new AuthService({
    client_id: clientId,
    redirect_uri: login,
    silent_redirect_uri: renew,
    post_logout_redirect_uri: logout,
    scope: 'openid profile email authorities',
  })

  return new Bootstrap(authService, { signinRedirect: false })
}

const useAuth = () => {
  const [bootstrap, setBootstrap] = useState()
  const [user, setUser] = useState()
  const [resourceAllowed, setResourceAllowed] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const api = useMemo(() => new AuthorizationApi(), [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const bootstrapOfCAS = getBootstrapOfCAS()

      bootstrapOfCAS.subscribe({
        next: async userData => {
          if (userData && userData.profile) {
            const { data } = await api.getResourceAllowed(userData.id_token)
            setResourceAllowed(data)
          }

          userData && localStorage.setItem('userId', userData?.profile?.id)
          setUser(userData)
          setIsLoading(false)
        },
      })
      bootstrapOfCAS.start({ signinRedirect: false })

      setBootstrap(bootstrapOfCAS)
    }
  }, [api])

  return {
    user,
    resourceAllowed,
    isLoading,
    bootstrap,
    setBootstrap,
  }
}

export default useAuth
